<template>
  <div class="radio-list">
    <h3>{{ title }}</h3>
    <div v-for="item in items" :key="item.id" class="radio-item">
      <label class="custom-radio">
        <input
          type="radio"
          :value="item.value"
          v-model="selectedValue"
          :name="name"
          @change="emitSelectedValue"
        />
        <span class="custom-circle"></span>
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-radio-list",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  methods: {
    emitSelectedValue() {
      this.$emit("update:selected", this.selectedValue);
    },
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 15px;
  font-family: UAF Sans;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #fff;
  max-width: 650px;
  color: #e2e2e2;
}
.radio-item {
  margin: 8px 0;
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  position: relative;
  margin-bottom: 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 130%;
  color: #e2e2e2;

  @media (max-width: 767px) {
    font-size: 22px;
  }
}

.custom-radio input[type="radio"] {
  display: none;
}

.custom-radio .custom-circle {
  width: 17px;
  height: 17px;
  top: 0;
  left: 0;
  background-color: #464649;
  border-radius: 50%;
  transition: 0.3s;
  margin-right: 15px;
  position: relative;

  @media (max-width: 767px) {
    width: 34px;
    height: 34px;
  }
}

.custom-radio input[type="radio"]:checked + .custom-circle {
  background-color: #fff;
}

.custom-radio .custom-circle::after {
  content: " ";
  top: 4px;
  left: 4px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #242424;
  display: none;
  position: absolute;
  @media (max-width: 767px) {
    top: 5px;
    left: 5px;
    width: 24px;
    height: 24px;
  }
}

.custom-radio input[type="radio"]:checked + .custom-circle::after {
  display: block;
}
</style>
